import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from 'reducers';
import { completedFormTexts, fundTypes } from 'utils/constants';
import { jsonParseSafe } from 'utils/helpers';

import Experience from './Experience';
import ExperienceFCPR from './ExperienceFCPR';

const ExperienceStep = props => {
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);
    const kycSurvey = useMemo(() => tunnelSubscription?.kycSurvey, [tunnelSubscription]);
    const isFCPR = useMemo(
        () => tunnelSubscription?.investmentFund?.type === fundTypes.FCPR,
        [tunnelSubscription]
    );

    // get dynamic text for form_1 and form_0 and form_2
    const getCompletedFormTitle = useCallback((form, formKey) => {
        const title = completedFormTexts[formKey].title;
        let values = [];

        if (formKey === 'form_5') {
            values = Object.keys(form).filter(
                (item, i) =>
                    form[item] !== 'financial_instruments_options.no_orders' && form[item] !== ''
            );
        }

        if (formKey === 'form_4' || formKey === 'form_36') {
            values = Object.keys(form.choice).filter(item => form.choice[item]);
        }

        if ((formKey === 'form_5' || formKey === 'form_36') && values.length < 1) {
            return <span>{completedFormTexts[formKey].noChoice} </span>;
        }

        const valueElements = values.map((item, i) => {
            if (values.length === 1 || i === values.length - 2) {
                return (
                    <span key={item}>
                        <strong> {completedFormTexts[formKey].choice[item]} </strong>
                    </span>
                );
            }
            if (i !== values.length - 1) {
                return (
                    <span key={item}>
                        <strong>
                            {completedFormTexts[formKey].choice[item] !== 'Autre'
                                ? completedFormTexts[formKey].choice[item]
                                : 'Autres'}
                            ,{' '}
                        </strong>
                    </span>
                );
            } else {
                return (
                    <span key={item}>
                        et
                        <strong>
                            {' '}
                            {completedFormTexts[formKey].choice[item] !== 'Autre'
                                ? completedFormTexts[formKey].choice[item]
                                : 'Autres'}
                        </strong>
                    </span>
                );
            }
        });

        return (
            <React.Fragment>
                <span>{title} </span>
                {valueElements}
            </React.Fragment>
        );
    }, []);

    const defaultForm_1 = useMemo(() => {
        const investmentsManagement = jsonParseSafe(kycSurvey?.investmentsManagement);

        const form_1_state = {
            choice: {
                'step36.question_2.option_1': false,
                'step36.question_2.option_2': false,
                'step36.question_2.option_3': false,
                'step36.question_2.option_4': false,
            },
            other: '',
        };

        if (investmentsManagement) {
            Object.keys(form_1_state.choice).forEach(key => {
                form_1_state.choice[key] = investmentsManagement.choice.indexOf(key) > -1;
            });

            form_1_state.other = investmentsManagement.choice.find(
                ch => ch.includes('option_4.option') // find the subOption of option_4
            );
        }

        return form_1_state;
    }, [kycSurvey]);

    return isFCPR ? (
        <ExperienceFCPR
            {...props}
            getCompletedFormTitle={getCompletedFormTitle}
            defaultForm_1={defaultForm_1}
            kycSurvey={kycSurvey}
        />
    ) : (
        <Experience
            {...props}
            getCompletedFormTitle={getCompletedFormTitle}
            defaultForm_1={defaultForm_1}
            kycSurvey={kycSurvey}
        />
    );
};

export default ExperienceStep;
